export default function EmptyState({ title, message, image, action }) {
  return (
    <div
      data-testid="empty-state"
      className="flex flex-col items-start justify-center px-6 py-10 gap-6 sm:flex-row sm:items-center"
    >
      {image && (
        <img
          src={image}
          alt="calm zen garden"
          className="w-full sm:w-48 max-h-40 object-cover rounded-md border border-white/10 grayscale contrast-125"
        />
      )}
      <div className="flex-1">
        <h3 className="text-xl font-bold tracking-tight">{title}</h3>
        <p className="mt-2 text-sm text-zinc-400 font-mono">{message}</p>
        {action && <div className="mt-4">{action}</div>}
      </div>
    </div>
  );
}
